<script lang="ts" module>
  import type { FooterGroupStoryblok } from '~/component-types-sb';

  export interface FooterGroupProps {
    blok: FooterGroupStoryblok;
  }
</script>

<script lang="ts">
  import { FooterGroup } from "@agapi/ui/footer";
  import { storyblokEditable, StoryblokComponent } from "@storyblok/svelte";

  const { blok }: FooterGroupProps = $props();
</script>

<FooterGroup use={[[storyblokEditable, blok]]}>
  {#if blok.content}
    {#each blok.content as nestedBlok}
      <StoryblokComponent blok={nestedBlok} />
    {/each}
  {/if}
</FooterGroup>
